var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { modalConfig: _vm.modalConfig },
          on: { onClose: _vm.dialog_btnClose },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请输入商品编码",
                        remote: "",
                        "reserve-keyword": "",
                        "remote-method": (query) => {
                          _vm.remoteMethod(query, "productCode")
                        },
                        loading: _vm.loading,
                        filterable: "",
                        clearable: "",
                      },
                      on: {
                        clear: function ($event) {
                          return _vm.getClear("productCode")
                        },
                        change: function ($event) {
                          return _vm.getChange($event, "productCode")
                        },
                      },
                      model: {
                        value: _vm.productCode,
                        callback: function ($$v) {
                          _vm.productCode = $$v
                        },
                        expression: "productCode",
                      },
                    },
                    _vm._l(_vm.productCodeOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.productCode,
                          value: item.productCode,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请输入商品名称",
                        remote: "",
                        "reserve-keyword": "",
                        "remote-method": (query) => {
                          _vm.remoteMethod(query, "productName")
                        },
                        loading: _vm.loading,
                        filterable: "",
                        clearable: "",
                      },
                      on: {
                        clear: function ($event) {
                          return _vm.getClear("productName")
                        },
                        change: function ($event) {
                          return _vm.getChange($event, "productName")
                        },
                      },
                      model: {
                        value: _vm.productName,
                        callback: function ($$v) {
                          _vm.productName = $$v
                        },
                        expression: "productName",
                      },
                    },
                    _vm._l(_vm.productNameOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.productName,
                          value: item.productCode,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              staticClass: "vxeTable",
              attrs: {
                data: _vm.tableList,
                border: "",
                "row-id": "productCode",
              },
              on: {
                "checkbox-change": _vm.dialog_checkboxChange,
                "checkbox-all": _vm.dialog_checkboxChange,
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "checkbox", width: "60" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "productCode",
                  title: "商品编号",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "productName",
                  title: "商品名称",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: { title: "操作", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ rowIndex, row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.delTable(rowIndex, row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-check",
                  },
                  on: { click: _vm.dialog_btnConfirm },
                },
                [_vm._v("提交 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    size: "small",
                    icon: "el-icon-close",
                  },
                  on: { click: _vm.dialog_btnClose },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }